export default "__VITE_ASSET__7dd08f39__"